import config from "../../config";
export default function ImageBlock({ src, alt, title }) {
  return <a href={config.partnerLink} rel="nofollow" className="image-link"><img src={src} alt={alt} title={title} className="main-img" /></a>

}
